import {
  IExtendedServiceLine,
  IService,
  IServiceDosage,
  IServiceOrderedServiceLine,
  TimePeriod,
} from '@alberta/konexi-shared';
import { Weekday } from '@alberta/konexi-shared/dist/general/enum/weekdays';
import { ignore } from '@common/tracking/tracker';
import { v4 } from 'uuid';
import { DurationViewModel } from '../../general/view-models/duration-view-model';
import { ServiceDosageViewModel } from '../../general/view-models/service-dosage-view-model';

export class ServiceOrderedServiceLineViewModel implements IServiceOrderedServiceLine {
  _id: string;
  timestamp: Date;
  archived: boolean;
  serviceId: string;
  contractId: string;
  /** the frequency of service (e.g. x tasks every y weeks) */
  dosage: IServiceDosage;
  /** the total number of tasks to be provided */
  quantity: number;
  visitStartTime: string;
  selectedVisitDays: Weekday[];
  /** false means that the user has to create the tasks manually, true or undefined means that the tasks are created automatically */
  automaticAppointmentCreation: boolean;
  @ignore() service: IService;
  @ignore() active: boolean;

  constructor() {
    this._id = v4();
    this.timestamp = new Date();
    this.archived = false;
    this.quantity = undefined;
    this.dosage = new ServiceDosageViewModel();
    this.dosage.billingUnitId = null;
    this.dosage.quantity = undefined;
    this.dosage.duration = new DurationViewModel();
    // For now we default the interval to 1 and hide the control to change it
    // until we have a clear use case for it.
    this.dosage.duration.amount = 1;
    this.dosage.duration.timePeriod = TimePeriod.Week;
  }

  public initialize(integratedCareServiceLine: IExtendedServiceLine, service: IService): void {
    this.service = service;
    this.serviceId = service._id;
    this.contractId = integratedCareServiceLine.contractId;
    this.visitStartTime = integratedCareServiceLine.visitStartTime;
    this.selectedVisitDays = integratedCareServiceLine.selectedVisitDays;
    this.automaticAppointmentCreation = integratedCareServiceLine.automaticAppointmentCreation ?? true;
    this.dosage.quantity = integratedCareServiceLine.selectedVisitDays?.length;
    const defaultBillingUnit = service.billingUnits?.find(bu => bu.defaultBillingUnit);
    this.dosage.billingUnitId = defaultBillingUnit?._id;
  }
}
